import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Utility } from "./utility";

@Injectable({
    providedIn: "root"
})
export class ScriptService {

    private scripts: any = {};
    private scriptStore = [{
        name: "amcharts", src: "./assets/amcharts/amcharts.js"
    },
    {
        name: "amcharts-light", src: "./assets/amcharts/light.js"
    },
    {
        name: "amcharts-pie", src: "./assets/amcharts/pie.js"
    },
    {
        name: 'amcharts-serial', src: "./assets/amcharts/serial.js"
    },
    {
        name: "svgaplayer", src: "./assets/lib/svga.min.js"
    },
    {
        name: "gtag", src: "https://www.googletagmanager.com/gtag/js?id={gtagID}"
    }
    ];
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private _utility: Utility
    ) {
        this.scriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: this._utility.getAbsUrl(script.src)
            };
        });
    }

    load(...scripts: string[]) {
        var promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }
    private pendingLoad: any = {};

    loadScript(name: string, options: {
        isHeadLoad: boolean,
        isAsync: boolean,
        params: any
    } = {
            isHeadLoad: true,
            isAsync: false,
            params: {}
        }) {
        if (this.pendingLoad[name]) {
            return this.pendingLoad[name];
        }
        this.pendingLoad[name] = new Promise((resolve, reject) => {
            if (this.scripts[name].loaded) {
                delete this.pendingLoad[name];
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
            else {
                //load script
                let script = this.document.createElement('script');

                let uri = this.scripts[name].src;
                Object.keys(options.params).forEach(item => {
                    uri = uri.replace(`{${item}}`, options.params[item]);
                });

                script.type = 'text/javascript';
                script.src = uri;
                script.async = options.isAsync;
                script.onload = () => {
                    delete this.pendingLoad[name];
                    this.scripts[name].loaded = true;
                    resolve({ script: name, loaded: true, status: 'Loaded' });
                };
                script.onerror = (error: any) => {
                    delete this.pendingLoad[name];
                    resolve({ script: name, loaded: false, status: 'Loaded' });
                }
                if (options.isHeadLoad)
                    document.getElementsByTagName('head')[0].appendChild(script);
                else {
                    document.body.appendChild(script);
                }
            }
        });
        return this.pendingLoad[name];
    }

}